export const environment = {
  remote: true,
  domain: 'dev.active-promotion.jp',
  // API_HOST と同居 (同一 origin) なので apiDomain は不要
  apiDomain: '',
  database: 'active-promotion',
  production: true,
};
